<template>
  <div>
    众包管理
  </div>
</template>

<script>
export default {

}
</script>
